// 定时器事件
export default {
    data(){
      return {
        liveTimer:{
          instance:null,
          startTime:"",
          speed:1.00,
          sleep:1000,
          index:0,
          currIndex:0
        },
        fileLoading:false,
        playerLoading:false,
        playerIsPlaying:false
      }
    },
    methods:{
      initTimer(currIndex) {
        if (this.liveTimer.instance) {
          clearTimeout(this.liveTimer.instance);
          this.liveTimer.instance = null;
        }
        // 需要方法写执行方法
        this.dealWithEvent()
        this.liveTimer.instance = setTimeout(()=>{
          if(this.liveTimer.currIndex != currIndex ) return;
          this.initTimer(currIndex)
        },this.liveTimer.sleep*this.liveTimer.speed)
      },
      runTimer(){
        this.changeIndex()
        setTimeout(()=>{
          this.initTimer(this.liveTimer.currIndex)
        },this.liveTimer.sleep + 100)
      },
      changeIndex(){
        this.liveTimer.currIndex = Math.floor(Math.random() * 10000)
      },
    //   dealWithEvent(){
    //     dealWith
    //   }
    }
  }